var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallblob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.805,
    height: 177.04,
    viewBox: "0 0 182.805 177.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M142.144,20.008c13.48,14.565,25.923,38.905,23.847,58.583s-5.417,50.253-18.9,69.621-46.8,23.557-64.987,24.146S47.568,154.4,30.8,135.037c-16.8-19.368-21.215-32.517-20.409-50.46.837-17.942,6.929-40.708,23.694-55.273C50.883,14.74,59.272,14.487,78.7,12.163s49.962-6.719,63.442,7.845",
    transform: "translate(193.827 13.786) rotate(98)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallblob2);
export default __webpack_public_path__ + "static/media/smallblob2.7772a2bbddad5271311e556ddaeb0da0.svg";
export { ForwardRef as ReactComponent };